// This powers the Course Search Results and dynamically updates the search results based on the filters selected
var initSubjectAreaFilter = function () {
    $('#subjectArea-filter').on('change', function (e) {
        SubjectAreaFilter();
    });

    $('#studyMode-filter').on('change', function (e) {
        SubjectAreaFilter();
    });

    $('#studyLocation-filter').on('change', function (e) {
        SubjectAreaFilter();
    });

    $('#scqfLevel-filter').on('change', function (e) {
        SubjectAreaFilter();
    });

    $('#availability-filter').on('click', function (e) {
        if ($(this).is(':checked')) {
            $('#availability-filter').val("1");
            SubjectAreaFilter();
        }
        else {
            $('#availability-filter').val("0");
            SubjectAreaFilter();
        }
    });

    // Reset all the things
    $('#clear').on('click', function (e) {
        e.preventDefault();

        var $availabilityInput = $('#availability-filter');

        $('#subjectArea-filter').val("0");
        $('#studyMode-filter').val("0");
        $('#studyLocation-filter').val("0");
        $('#scqfLevel-filter').val("0");
        if ($availabilityInput.is(':checked')) {
            $availabilityInput.val("0");
            $availabilityInput.prop("checked", false);
        }
        else {
            $availabilityInput.val("0");
        }
        SubjectAreaFilter();
    });
};

function SubjectAreaFilter() {
    var teachingAreaName = $('#teachingAreaName').val();

    var subjectArea = $('#subjectArea-filter').val();
    var studyMode = $('#studyMode-filter').val();
    var studyLocation = $('#studyLocation-filter').val();
    var scqfLevel = $('#scqfLevel-filter').val();
    var availability = $('#availability-filter').val();

    var $target = $('#courseList');

    $.ajax({
        url: '/subjectareasfilter/teachingareacourses',
        data: { 'subjectArea': subjectArea, 'studyMode': studyMode, 'studyLocation': studyLocation, 'scqfLevel': scqfLevel, 'teachingAreaName': teachingAreaName, 'availability': availability },
        traditional: true,
        dataType: "json",
        complete: function (data) {
            $target.html(data.responseText);
        }
    });
}

document.addEventListener("DOMContentLoaded", function () {
    initSubjectAreaFilter();
});